import React from 'react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'text-[20px]',
  md: 'text-[24px]',
  lg: 'text-[32px]'
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  className,
  size = 'sm'
}) => (
  <span 
    className={cn(
      "material-symbols-outlined animate-spin inline-block",
      sizeClasses[size],
      className
    )}
    style={{ 
      fontVariationSettings: "'FILL' 1"
    }}
  >
    progress_activity
  </span>
); 